window.updateCart = function(productIdArray) {
  productIdArray.forEach(function(Vid) {
    var data = { quantity: 1, id: Vid };
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      async: false,
      dataType: 'json',
      success: function(data) {
        var tt = $('.ProductForm__AddToCart[variant-id="' + Vid + '"]');
        tt.html(
          '<i class="fa fa-spinner fa-spin" style="font-size:12px;"></i>  Adding..'
        );
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  // Refreshing the cart for prestige theme
        }));

        setTimeout(function() {
          var cart_count = $('.Header__CartDot.is-visible').text();
          $('.cart__popup_main').show();
          $('.cart__popup_count').text(cart_count);
          var total_count = $('.Cart__Checkout').attr('cart-price');
          $('.cart_popup_price').text(total_count);
          $.getJSON('/cart', function(cart) {
            var totalPrice = cart.total_price;
            add_three_free_items(totalPrice);
          });
        }, 100);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        var tt = $('.ProductForm__AddToCart[variant-id="' + Vid + '"]');
        tt.html("Add to bag");

        let statusCode = jqXHR.status;
        let errorMessage = 'An error occurred while adding the product. Please try again later.';
        
        if (statusCode === 422) {
          errorMessage = 'Sold out';
        } else if (jqXHR.responseJSON && jqXHR.responseJSON.description) {
          errorMessage = jqXHR.responseJSON.description;
        } else if (errorThrown) {
          errorMessage = errorThrown;
        }

        let errorResponse = { statusCode: statusCode, errorMessage: errorMessage };
        console.error('Error adding product to cart:', errorResponse);

        // Display the error message on the user interface (example)
        $('.error-message').text(errorResponse.errorMessage).show();
      },
      complete: function() {
        setTimeout(function() {
          var tt = $('.ProductForm__AddToCart[variant-id="' + Vid + '"]');
          tt.html("Add to bag");
          $('.cart__popup_main').hide();
        }, 3000);
      }
    });
  });
};
$(document).ready(function () {
   $(".back_btn").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });
  
    var goto = localStorage.getItem("goto");
    localStorage.removeItem("goto");
    if (goto && goto != 'null') {
    window.location.href = goto;
    }

   // Redirect to Checkout if user comeback from checkout
    var history_prevUrl = localStorage.getItem('prevUrl');
    if(history_prevUrl != null){
      localStorage.removeItem('prevUrl');
      window.location.href = history_prevUrl
    }

   // To open the Cart drawer if user come through cart  drawer
  setTimeout(function() {
    var from = localStorage.getItem('from');
    // console.log('from value>>>', from);
    if (from) {
      localStorage.removeItem('from');
      $('a[data-action="open-drawer"]')[0].click();
    }
  }, 3000);
});

// footer accordian js

$(".footer-acc-heading").click(function (e) {
  e.preventDefault();
  let $this = $(this);
  if ($this.hasClass("show-acc")) {
    $this.removeClass("show-acc");
    $this.next().slideUp(350);
  } else {
    $this.parent().parent().find(".footer-acc-heading").removeClass("show-acc");
    $this.parent().parent().find(".footer-acc-content").slideUp(350);
    $this.toggleClass("show-acc");
    $this.next().slideToggle(350);
  }
});
// end footer accordian

// footer-look acc-js
// $(".looks-icon-heading").click(function () {
//   $(this).parent().toggleClass("active");
//   $(this)
//     .parent()
//     .find(".footer-looks-linklist")
//     .slideToggle()
//     .toggleClass("active");
// });
// end footer-look acc-js

$(".Popover__Value").click(function () {
  var selected_opt = $(this).attr("data-value");
  document.querySelector(`[data-tooltip="${selected_opt}"]`).click();
});

//image alt code & expiry code
window.addEventListener("load", (event) => {
  // YMK code
  window.ymkAsyncInit = function () {
    window.YMK.init({
      skinSmoothStrength:30
    });
    window.YMK.addEventListener("opened", function () {});

    window.YMK.addEventListener("reset", function () {});
    window.YMK.addEventListener("compare", function () {});
    window.YMK.addEventListener("videoLoaded", function () {});
    window.YMK.addEventListener("photoLoaded", function () {});
    window.YMK.addEventListener("loaded", function () {});
    window.YMK.addEventListener("shadeFinderComplete", function (r) {});
  };

  function snapshot2blob() {
    window.YMK.snapshot("blob", function (result) {});
  }
  function snapshot2base64() {
    window.YMK.snapshot("base64", function (result) {});
  }

  function loadImage() {
    var file = document.getElementById("imageData").files[0];
    if (file) {
      window.YMK.open(file);
    }
  }

  function applyMakeupManual() {
    const itemGuid = document.getElementById("itemGuid");
    YMK.applyMakeupBySku(itemGuid.value);
  }

  function applyLookManual() {
    const lookGuid = document.getElementById("lookGuid");
    YMK.applyMakeupByLook(lookGuid.value);
  }
  var window_url = window.location.href.split(".com/");
  if (window_url[1].includes("product")) {
    var getCollection = document.querySelector(".ColorSwatchList ");
    if (getCollection) {
      var getCollectionTitle = getCollection.getAttribute("get-collection");
      if (getCollectionTitle) {
        if (getCollectionTitle.includes("Value Sets & Combos")) {
        }
      } else {
        var input_field = document.querySelectorAll(".ColorSwatch__Radio");
        for (var i = 0; i < input_field.length; i++) {
          if (input_field[i].checked == true) {
            var input_title = input_field[i].getAttribute("value");
            input = input_title.toLowerCase().replaceAll(" ", "-");
            var navImages = document.querySelectorAll(
              ".Product__SlideshowNavImage.AspectRatio"
            );
            navImages.forEach(function (navImage) {
              var alt = navImage.querySelector("img").getAttribute("alt");
              if (alt === input) {
                navImage.style.display = "inline-block";
              } else {
                navImage.style.display = "none";
              }
            });
          }
        }
      }
    }
  }
});

$(document).ready(function () {
  var goto = localStorage.getItem("goto");
  localStorage.setItem("goto", "");
  if (goto) {
    window.location.href = goto;
  }
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.color-swatch');
  if (!swatch) return;

  const card = swatch.closest('.ProductItem');
  if (!card) {
    console.log('❌ [Index Swatch] Parent .ProductItem not found');
    return;
  }

  // sirf homepage ke swatches ke liye chalao (jinke paas .product-slick nahi hota)
  if (card.querySelector('.product-slick')) {
    console.log('ℹ️ [Index Swatch] .product-slick mil gaya, skip — dusra handler ye sambhalega');
    return;
  }

  const shadeTitle = (swatch.getAttribute('title') || swatch.getAttribute('data-shade') || '').trim().toLowerCase();
  console.log('🟢 [Index Swatch] Clicked shade:', shadeTitle);

  if (!shadeTitle) {
    console.log('❌ [Index Swatch] title/data-shade attribute khaali hai swatch pe');
    return;
  }

  const heroImg = card.querySelector('.ProductItem__ImageWrapper .ProductItem__Image:not(.ProductItem__Image--alternate)');
  console.log('🖼️ [Index Swatch] Hero image element:', heroImg);

  if (!heroImg) {
    console.log('❌ [Index Swatch] Hero <img> element nahi mila card ke andar');
    return;
  }

  // 1) agar swatch pe direct image url hai
  const directUrl = swatch.getAttribute('data-variant-image');
  console.log('🔗 [Index Swatch] data-variant-image attribute:', directUrl);

  if (directUrl) {
    heroImg.setAttribute('src', directUrl);
    heroImg.setAttribute('data-src', directUrl);
    heroImg.setAttribute('data-loaded', 'true');
    console.log('✅ [Index Swatch] Image set via data-variant-image:', directUrl);
    return;
  }

  // 2) warna card ke andar alt-text match karke dhoondo
  let matchedImg = null;
  card.querySelectorAll('img[alt]').forEach(function (img) {
    if (matchedImg) return;
    const alt = img.getAttribute('alt').trim().toLowerCase().replace(/\s+/g, '-');
    if (alt === shadeTitle) matchedImg = img;
  });

  console.log('🔍 [Index Swatch] Alt-text match result:', matchedImg);

  if (!matchedImg) {
    console.log('❌ [Index Swatch] Koi <img alt="' + shadeTitle + '"> nahi mila card ke andar. ' +
      'Iska matlab: is variant/shade ki koi separate media (image with matching alt) product ke media list mein set nahi hai.');
    return;
  }

  const newSrc = matchedImg.getAttribute('data-src') || matchedImg.getAttribute('src');
  console.log('🖼️ [Index Swatch] Naya image src milega:', newSrc);

  heroImg.setAttribute('src', newSrc);
  heroImg.setAttribute('data-src', newSrc);
  heroImg.setAttribute('data-loaded', 'true');

  console.log('✅ [Index Swatch] Hero image update ho gayi:', newSrc);
});
  // ************* Fb Pixel Event Code Start **************

  let searchStatus = localStorage.setItem("set_search_input", "false");
  let searchItems = localStorage.setItem("set_search_items", "false");
  $("body").on(
    "keyup",
    "#stDesktopSearchBox input,#stMobileSearchBox input",
    function () {
      let searchTapInput = $(this).val();
      localStorage.setItem("set_search_input", searchTapInput);
      if (searchTapInput == "" || searchTapInput == null) {
        localStorage.setItem("set_search_input", "false");
        localStorage.setItem("set_search_items", "");
      }
      if (searchTapInput.trim() !== "") {
        setTimeout(function () {
          let searchTapItems = $(".st_totl_count")
            .text()
            .replace("-", "")
            .trim();
          localStorage.setItem("set_search_items", searchTapItems);
          fbq("track", "Search", {
            search_items: localStorage.getItem("set_search_items"),
            search_string: localStorage.getItem("set_search_input"),
          });
        }, 1000);
      }
    }
  );
  $("body").on("click", ".st-search-icon", function () {
    setTimeout(function () {
      localStorage.setItem("set_search_collection", "true");
    }, 1000);
  });
  window.addEventListener("load", (event) => {
    if (localStorage.getItem("set_search_collection")) {
      if (window.theme.pageType === "collection") {
        fbq("track", "Search", {
          search_items: $(".SectionHeader").attr("collection_product_count"),
          search_string: $(".SectionHeader__Heading.Heading.u-h1.margin-0")
            .text()
            .trim(),
        });
      }
      if (window.theme.pageType === "page") {
        setTimeout(function () {
          let count = 0;
          $(
            "#shopify-section-sale-page-new-banner-design .Grid .Grid__Cell"
          ).each(function () {
            count++;
          });
          fbq("track", "Search", {
            search_items: count,
            search_string: "Best Deals",
          });
        }, 1000);
      }
      if (
        window.theme.pageType === "page" ||
        window.theme.pageType === "collection"
      ) {
        setTimeout(function () {
          localStorage.removeItem("set_search_collection", "");
        }, 10000);
      }
    }
    if (window.theme.pageType === "customers/account") {
      let _loyaltyPoints = $("#loyalty_point_wallet_balance").text().trim();
      let _loyaltyPoint_Int = parseInt(_loyaltyPoints);
      if (_loyaltyPoint_Int >= 2200) {
        const get_date = new Date();
        localStorage.setItem("after_set_newUser", get_date.getDay());
        if (
          localStorage.getItem("after_set_newUser") ===
          localStorage.getItem("set_newUser")
        ) {
          fbq("track", "CompleteRegistration", {
            status: "successfully registered",
          });
          setTimeout(function () {
            localStorage.removeItem("set_newUser");
          }, 30000);
        }
      }
    }
    let template = window.location.href;
    let templateName = template.includes("/products/");
    if (templateName) {
      setTimeout(function () {}, 2000);
    }
  });

 
});
// code for lipstick comobo for change image slider
$("body").on("click", ".ColorSwatch__Radio", function () {
  var data_value = $(this).attr("value");
  var imagePick = $(
    '.Product__SlideshowNavImage img[alt="' + data_value + '"]'
  );
  if (imagePick.length > 0) {
    imagePick[0].click();
  } else {
  }
});
//  end code for lipstick comobo for change image slider

$("body").on("click", "#cart_icon", function (e) {
  e.preventDefault();
});
$("body").on(
  "click",
  ".CartItem__Remove, .quantity-minus, .quantity-plus",
  function (e) {
    e.preventDefault();
  }
);
// For bundle 7OA_images
if ($(".ColorSwatch").length > 0) {
  setTimeout(function () {
    $(".ColorSwatch").eq(0).click();
  }, 1000);
  $(".ColorSwatch").click(function () {
    var b = $(this).attr("tags");
    if (b && b.includes("70A_image")) {
      var tooltip = $(this).attr("data-tooltip");
      $(".Product__SlideshowNavImage").addClass("none");
      $('.Product__SlideshowNavImage img[alt="' + tooltip + '"]')
        .parent()
        .removeClass("none");
    }
  });
}
// cart-drawer payment-details accordian
$("body").on("click", ".plus_expand", function () {
  $(".expand_box").slideDown();
  $(this).addClass("hide");
  $(".minus_expand").addClass("show");
});
$("body").on("click", ".minus_expand", function () {
  $(".expand_box").slideUp();
  $(this).removeClass("show");
  $(".plus_expand").removeClass("hide");
});
// end cart-drawer payment-details accordian

// When tap on cart-drawer delete there showing popup

$(document).ready(function () {
  $(".Header__Icon").css("pointer-events", "auto");
  $(".VirtualBanner-Parnt").css("visibility", "visible");
});

var url1 = "https://www.lakmeindia.com/products/lakme-cushion-matte-2";
var url2 =
  "https://www.lakmeindia.com/products/lakme-9-to-5-primer-matte-perfect-cover-foundation-mini-1";
var url3 = "https://www.lakmeindia.com/pages/mini-foundation-new";

var a = document.querySelector(".Header__LogoLink"); // Declare 'a' outside of the conditional blocks

// comments on 22-10-24
$(document).ready(function () {
  $(".ProductForm__AddToCart").click(function () {
    gtag("event", "add to cart", {
      send_to: "AW-643588700/1vpFCNmt1IEZENzE8bIC",
    });
  });
});


// $(document).ready(function () {
//   $("body").on("click", ".Cart__Checkout", function () {
//     gtag("event", "begin_checkout", {
//       send_to: "AW-643588700/ONlXCIHqws8BENzE8bIC",
//     });
//   });
// });

// $(document).ready(function () {
//   $(".ProductForm__AddToCart").click(function () {
//     gtag("event", "add to cart", {
//       send_to: "AW-10869353894/9JfhCP7orIoYEKbb9L4o",
//     });
//   });
// });

// $(document).ready(function () {
//   $(".ProductForm__AddToCart").click(function () {
//     gtag("event", "add to cart", {
//       send_to: "DC-73774990",
//     });
//   });
// });
// $(document).ready(function () {
//   $(".ProductForm__AddToCart").click(function () {
//     gtag("event", "add to cart", {
//       send_to: "AW-11118290062",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".Cart__Checkout", function () {
//     gtag("event", "begin_checkout", {
//       send_to: "AW-1000669193",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".Cart__Checkout", function () {
//     gtag("event", "begin_checkout", {
//       send_to: "AW-10869353894",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".Cart__Checkout", function () {
//     gtag("event", "begin_checkout", {
//       send_to: "AW-11118290062",
//     });
//   });
// });
//  code for whatsapp icon [visible only between 10am - 7pm]
// $(document).ready(function () {
//   $(".ProductForm__AddToCart").click(function () {
//     gtag("event", "add to cart", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

var today = new Date();
var currentHours = today.getHours();
var currentMinutes = today.getMinutes();
var currentSeconds = today.getSeconds();
setTimeout(function () {
  if (
    (currentHours > 10 && currentHours < 19) ||
    (currentHours === 10 && currentMinutes >= 0) ||
    (currentHours === 19 && currentMinutes === 0 && currentSeconds === 0)
  ) {
    if (today.getDay() == 0 || !today.getDay()) {
      $(".WhatsAppButton__root").css("display", "none");
    } else {
      $(".WhatsAppButton__root").css("display", "block");
    }
  } else {
    $(".WhatsAppButton__root").css("display", "none");
  }
}, 1000);
// end for whatsapp icon [visible only between 10am - 7pm]

$("body").on("click", ".quantity-minus", function () {
  var prod = $(this).attr("data-product-id");
  var qty = $(this).next().val();
  if (prod == "7518174871687" && qty == 1) {
    removeItem();
  }
});

function removeItem() {
  var combovId = 39593732046983;
  var data = { updates: {} };
  data.updates[combovId] = 0;
  jQuery.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: data,
    async: false,
    dataType: "json",
    success: function () {},
  });
}

$(document).ready(function () {
  $(".color_swatch_val").click(function () {
    var v_id = $(this).attr("data-variant-id");
    var vvn = $(this).attr("name");
    var v_t = $(this);
    var select = v_t.parent().parent().parent().find(".first_product_attr_1");

    v_t
      .parent()
      .parent()
      .parent()
      .find(".first_product_attr_1")
      .val(v_id)
      .trigger("change");

    //select.value = v_id;
    //select.dispatchEvent(new Event("change"));
  });
  $(".HorizontalList__Item_shades input").click(function () {
    var v_id = $(this).attr("data-variant-id");


    //$('#product-select-6846971969671').val().trigger('change');

    // var select = document.querySelector(".first_product_attr_1");

    // select.value = v_id;

    // select.dispatchEvent(new Event("change"));
  });
});

// GA4 event DFN page
//  commented this code because this is not using 13-August
// $(document).ready(function () {
//   $("body").on("click", ".3lips_eventsd", function () {
//     gtag("event", "MultiSlayerStick_AR_Start_Homepage", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".btn_events2", function () {
//     gtag("event", "MultiSlayerStick_AR_Start_tutorial", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".btn_events5", function () {
//     gtag("event", "MultiSlayerStick_AR_GetTheLook", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".steps_count_1", function () {
//     gtag("event", "MultiSlayerStick_AR_GetTheLook_Step1", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });
// $(document).ready(function () {
//   $("body").on("click", ".steps_count_2", function () {
//     gtag("event", "MultiSlayerStick_AR_GetTheLook_Step2", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });
// $(document).ready(function () {
//   $("body").on("click", ".steps_count_3", function () {
//     gtag("event", "MultiSlayerStick_AR_GetTheLook_Step3", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });
// $(document).ready(function () {
//   $("body").on("click", ".steps_count_4", function () {
//     gtag("event", "MultiSlayerStick_AR_GetTheLook_Step4", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });
// $(document).ready(function () {
//   $("body").on("click", ".steps_count_5", function () {
//     gtag("event", "MultiSlayerStick_AR_GetTheLook_Step5", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".btn_events4", function () {
//     gtag("event", "MultiSlayerStick_AR_TryAgain", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });
// $(document).ready(function () {
//   $("body").on("click", ".btn_events", function () {
//     gtag("event", "MultiSlayerStick_AR_ShopTheLook", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".foundation_1", function () {
//     gtag("event", "MultiSlayerStick_AR_Start_foundation_pdp", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });
// $(document).ready(function () {
//   $("body").on("click", ".contour_1", function () {
//     gtag("event", "MultiSlayerStick_AR_Start_contour_pdp", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });
// $(document).ready(function () {
//   $("body").on("click", ".highlighter_1", function () {
//     gtag("event", "MultiSlayerStick_AR_Start_highlighter_pdp", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });
// $(document).ready(function () {
//   $("body").on("click", ".blush_1", function () {
//     gtag("event", "MultiSlayerStick_AR_Start_blush-pdp", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".copiedIcon", function () {
//     gtag("event", "MultiSlayerStick_AR_CouponCodeCopied", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".try_on_events", function () {
//     gtag("event", "MultiSlayerStick_try_defineU", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".homepage_banner2", function () {
//     gtag("event", "MultiSlayerStick_AR_Start_Homepage_banner2", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

$(document).ready(function () {
  $("body").on("click", ".try_now_event1_1", function () {
    gtag("event", "Try_on", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

// $(document).ready(function () {
//   $("body").on("click", ".try_now_event1_2", function () {
//     gtag("event", "shade_finder_try_on", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

$(document).ready(function () {
  $("body").on("click", ".try_now_event1_3", function () {
    gtag("event", "Skin_analyser_try_on", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".try_on_btnnn", function () {
    gtag("event", "try_on", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

// $(document).ready(function () {
//   $("body").on("click", ".shade_fnder_ty_on", function () {
//     gtag("event", "shade_finder_try_on", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

$(document).ready(function () {
  $("body").on("click", ".1lips_events", function () {
    gtag("event", "minis_icon_hp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".2lips_events", function () {
    gtag("event", "sale_icon_hp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".3lips_events", function () {
    gtag("event", "face_icon_hp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".4lips_events", function () {
    gtag("event", "lips_icon_hp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".5lips_events", function () {
    gtag("event", "eyes_icon_hp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".6lips_events", function () {
    gtag("event", "skin_icon_hp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".7lips_events", function () {
    gtag("event", "nail_icon_hp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

// 6-10-24 Configure events by dheeraj

$(document).ready(function () {
  $("body").on("click", ".5lips_events", function () {
    gtag("event", "Lips_try_on", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".1lips_events", function () {
    gtag("event", "Lips_try_on", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".1try_now_events", function () {
    gtag("event", "try_on_matte", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".2try_now_events", function () {
    gtag("event", "try_on_satin", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".3try_now_events", function () {
    gtag("event", "try_on_gloss", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".4try_now_events", function () {
    gtag("event", "try_on_tint", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".try_on_closed_bttn", function () {
    gtag("event", "try_on_closed", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".try_on_cart", function () {
    gtag("event", "try_on_cart", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".try_now", function () {
    gtag("event", "try_on_pdp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

//  commented this code because this is not using 13-August
// $(document).ready(function () {
//   $("body").on("click", ".1lips_eventsd", function () {
//     gtag("event", "Shoppable_page_hp_banner1", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

// $(document).ready(function () {
//   $("body").on("click", ".shadeFinder_tag", function () {
//     gtag("event", "shade_finder_pdp", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

//  commented this code because this is not using 13-August
// $(document).ready(function () {
//   $("body").on("click", ".2lips_eventsd", function () {
//     gtag("event", "Vitc_hp_banner2", {
//       send_to: "G-BHWZP5NNF8",
//     });
//   });
// });

$(document).ready(function () {
  $("body").on("click", ".try_on_cartss", function () {
    gtag("event", "try_on_cart", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".buynow_mattebullet", function () {
    gtag("event", "buynow_mattebullet", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".buynow_lipliq", function () {
    gtag("event", "buynow_lipliq", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".buynow_eyeshadow", function () {
    gtag("event", "buynow_eyeshadow", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".buynow_powderblush", function () {
    gtag("event", "buynow_powderblush", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".buynow_settingpowder", function () {
    gtag("event", "buynow_settingpowder", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".try_on_roughbloom", function () {
    gtag("event", "try_on_roughbloom", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".try_on_eyeshadow", function () {
    gtag("event", "try_on_eyeshadow", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".apply_makup_vto", function () {
    gtag("event", "apply_makeup_eyeshadow", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});


$(document).ready(function () {
  $("body").on("click", ".try_on_mattebullet", function () {
    gtag("event", "try_on_mattebullet", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".try_on_blush", function () {
    gtag("event", "try_on_blush", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".checkprices", function () {
    gtag("event", "roughbloom_buyonline", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".bSo96", function () {
    gtag("event", "signup_singin_checkout", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".signin-option", function () {
    gtag("event", "signup_singin_pdp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".squad-image", function () {
    gtag("event", "signup_pdp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".desktop-register", function () {
    gtag("event", "signup_pdp", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", "welcome-cta-button", function () {
    gtag("event", "skin_analyzer_start", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".retake", function () {
    alert("ytdtytdytd");
    gtag("event", "skin_analyzer_start", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".1makeuppro_vto", function () {
    gtag("event", "lips_try_on", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".2makeuppro_vto", function () {
    gtag("event", "eyes_try_on", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".3makeuppro_vto", function () {
    gtag("event", "face_try_on", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
// homepage banners events and lumi icon event added 13-August
$(document).ready(function () {
  $("body").on("click", ".banner-mobile-only-img", function () {
    gtag("event", "LUMI_Banner_click", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".1lips_eventsd", function () {
    gtag("event", "plump_lip_oil_banner1", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".2lips_eventsd", function () {
    gtag("event", "eyeconic_range_banner2", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".3lips_eventsd", function () {
    gtag("event", "hya_dewy_blush_banner3", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".4lips_eventsd", function () {
    gtag("event", "hya_lip_satin_banner4", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".5lips_eventsd", function () {
    gtag("event", "hya_cushion_fundation_banner5", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".6lips_eventsd", function () {
    gtag("event", "hya_lip_duo_banner6", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".chat-toggle", function () {
    gtag("event", "lumi_icon", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".6try_before", function () {
    gtag("event", "shade_match_try_before", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".7try_before", function () {
    gtag("event", "skin_analysis_try_before", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".8try_before", function () {
    gtag("event", "lips_try_before", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".9try_before", function () {
    gtag("event", "looks_try_before", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
$(document).ready(function () {
  $("body").on("click", ".10try_before", function () {
    gtag("event", "eyes_try_before", {
      send_to: "G-BHWZP5NNF8",
    });
  });
});
// Get the current page URL
var pageUrl = window.location.href;

// Check if the current page is the homepage
if (pageUrl === "https://www.lakmeindia.com/") {
  $(document).ready(function () {
    // Check if the user came from the "lakme-skin-pro" page
    var referrer = document.referrer;
    if (referrer === "https://www.lakmeindia.com/pages/lakme-skin-pro") {
      // Fire the session_end_skinpro event if redirected from the specified page
      
      gtag("event", "session_end_skinpro", {
        send_to: "G-BHWZP5NNF8",
      });
    }
  });
}

// Fire the session_start_skinpro event if the current page is "lakme-skin-pro"
if (pageUrl === "https://www.lakmeindia.com/pages/lakme-skin-pro") {
  $(document).ready(function () {
    gtag("event", "session_start_skinpro", {
      send_to: "G-BHWZP5NNF8",
    });
  });
}


// END GA4 event DFN page

//  dhaga clutch offer with get-the-look collection [28-03-2024]
var addtoCart = document.querySelectorAll(".ProductForm__AddToCart");
var addtoCartArray = Array.from(addtoCart);

var PriceOfferAddItems = [];
PriceOfferAddItems.push({
  id: 39559775944839,
  quantity: 1,
  properties: {
    _data_free: "get-the-look",
  },
});

function addee() {
  var AddParam = {
    items: PriceOfferAddItems,
  };
  $.ajax({
    url: "/cart/add.js",
    dataType: "json",
    cache: false,
    type: "post",
    data: AddParam,
    success: function (data) {},
  });
}


// code for lips category try on [19-07-2024]
$(document).ready(function () {
  $(".collection_try_on").click(function () {
    // Optional: Additional actions when collection_try_on is clicked
  });
  // Check if the URL has the 'try-on' parameter
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("try-on") && urlParams.get("try-on") === "true") {
    $(".button-virtual-try-it").trigger("click");
  }
  setTimeout(function () {
    $(".Product__Slideshow img").css("display", "block");
    $(".Product__SlideshowNavImage img").css("display", "block");
  }, 2000);
});

//  pdp shade selection

document.addEventListener("DOMContentLoaded", function () {
  const shadeLinks = document.querySelectorAll(".parent_shade a");
  const variantItems = document.querySelectorAll(".ColorSwatchList .HorizontalList__Item");

  function clickFirstMatchingItem(selectedShade) {
    // Find the first item that matches the selectedShade
    const firstMatchingItem = Array.from(variantItems).find(item => {
      const inputElement = item.querySelector(".ColorSwatch__Radio");
      const inputValue = inputElement.getAttribute("metafield");
      const inputLastWord = inputValue.split(" ").pop().toLowerCase();
      return selectedShade === "all" || inputLastWord === selectedShade.toLowerCase();
    });
    
    if (firstMatchingItem) {
      // Trigger a click event on the first matching item
      const inputElement = firstMatchingItem.querySelector(".ColorSwatch");
      if (inputElement) {
        inputElement.click();
      }
    }
  }

  shadeLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const selectedShade = this.getAttribute("data-shade").toLowerCase();
      let matchFound = false;

      // Check if there are matching items
      variantItems.forEach((item) => {
        const inputElement = item.querySelector(".ColorSwatch__Radio");
        const inputValue = inputElement.getAttribute("metafield");
        const inputLastWord = inputValue.split(" ").pop().toLowerCase();

        if (selectedShade === "all" || inputLastWord === selectedShade) {
          matchFound = true;
        }
      });

      if (!matchFound) {
        this.style.display = "none"; // Hide the link if no matching items
        e.preventDefault();
        return;
      }

      // Remove active class from all links
      shadeLinks.forEach((link) => link.classList.remove("active-shade"));

      // Add active class to the clicked link
      this.classList.add("active-shade");

      variantItems.forEach((item) => {
        const inputElement = item.querySelector(".ColorSwatch__Radio");
        const inputValue = inputElement.getAttribute("metafield");
        const inputLastWord = inputValue.split(" ").pop().toLowerCase();

        if (selectedShade === "all" || inputLastWord === selectedShade) {
          item.style.display = "block";
          item.classList.add("round-border");
        } else {
          item.style.display = "none";
          item.classList.remove("round-border");
        }
      });

      // Click the first matching item
      clickFirstMatchingItem(selectedShade);
    });
  });

  // Initial check to hide shade links with no matching items
  shadeLinks.forEach((link) => {
    const selectedShade = link.getAttribute("data-shade").toLowerCase();
    let matchFound = false;

    variantItems.forEach((item) => {
      const inputElement = item.querySelector(".ColorSwatch__Radio");
      const inputValue = inputElement.getAttribute("metafield");
      const inputLastWord = inputValue.split(" ").pop().toLowerCase();

      if (selectedShade === "all" || inputLastWord === selectedShade) {
        matchFound = true;
      }
    });

    if (!matchFound) {
      link.style.display = "none"; // Hide the link if no matching items
    }
  });

  // Initial call to click the first matching item (if any) on page load
  const activeShadeLink = document.querySelector(".parent_shade .active-shade");
  if (activeShadeLink) {
    clickFirstMatchingItem(activeShadeLink.getAttribute("data-shade"));
  }
});

$(".see_more").click(function () {
  $(this).css("display", "none");
  $(".mobile_desc").css("display", "block");
  $(".see_less").css("display", "flex");
  $(".see_less").css("flex-direction", "column");
  $(this)
    .parents("#mob_description")
    .find(".a_plus_banner")
    .css("height", "auto");
});
$(".see_less").click(function () {
  $(this).css("display", "none");
  $(".mobile_desc").css("display", "none");
  $(".see_more").css("display", "flex");
  $(".see_more").css("flex-direction", "column");
  $(".a_plus_banner").css("height", "150px");
  $('html, body').animate({
    scrollTop: $('#mob_description').offset().top
  }, 1800);
});
$(".about-us_more").click(function () {
  $(this).css("display", "none");
  $(".about-us_p").css("display", "block");
  $(".about-us_less").css("display", "flex");
  $(".about-us_less").css("flex-direction", "column");
});
$(".about-us_less").click(function () {
  $(this).css("display", "none");
  $(".about-us_p").css("display", "none");
  $(".about-us_more").css("display", "flex");
  $(".about-us_more").css("flex-direction", "column");
});
$(".open_main_cust_search_bar").click(function (event) {
  event.preventDefault();
  $(".main_cust_search_bar").toggle(function () {
    if ($(this).is(":visible")) {
      $(".wizz").focus().click();
    }
  });
  $(".searchs-form").toggle(function () {
    if ($(this).is(":visible")) {
      $(".wizzzz").focus().click();
    }
  });
});
$(".main_cust_close_icon").click(function () {
  $(".main_cust_search_bar").css("display", "none");
});
$(".searchs-form_close_icon").click(function () {
  $(".searchs-form").css("display", "none");
});

document.addEventListener("DOMContentLoaded", function () {
  const shadeLinks = document.querySelectorAll(".parent_shade a");
  const variantItems = document.querySelectorAll(
    ".ColorSwatchList .HorizontalList__Item"
  );

  shadeLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const selectedShade = this.getAttribute("data-shade").toLowerCase();
      let matchFound = false;

      // Check if there are matching items
      variantItems.forEach((item) => {
        const inputElement = item.querySelector(".ColorSwatch__Radio");
        const inputValue = inputElement.getAttribute("metafield");
        const inputLastWord = inputValue.split(" ").pop().toLowerCase();

        if (selectedShade === "all" || inputLastWord === selectedShade) {
          matchFound = true;
        }
      });

      if (!matchFound) {
        this.style.display = "none"; // Hide the link if no matching items
        e.preventDefault();
        return;
      }

      // Remove active class from all links
      shadeLinks.forEach((link) => link.classList.remove("active-shade"));

      // Add active class to the clicked link
      this.classList.add("active-shade");

      variantItems.forEach((item) => {
        const inputElement = item.querySelector(".ColorSwatch__Radio");
        const inputValue = inputElement.getAttribute("metafield");
        const inputLastWord = inputValue.split(" ").pop().toLowerCase();

        if (selectedShade === "all" || inputLastWord === selectedShade) {
          item.style.display = "block";
          item.classList.add("round-border");
        } else {
          item.style.display = "none";
          item.classList.remove("round-border");
        }
      });
    });
  });

  // Initial check to hide shade links with no matching items
  shadeLinks.forEach((link) => {
    const selectedShade = link.getAttribute("data-shade").toLowerCase();
    let matchFound = false;

    variantItems.forEach((item) => {
      const inputElement = item.querySelector(".ColorSwatch__Radio");
      const inputValue = inputElement.getAttribute("metafield");
      const inputLastWord = inputValue.split(" ").pop().toLowerCase();

      if (selectedShade === "all" || inputLastWord === selectedShade) {
        matchFound = true;
      }
    });

    if (!matchFound) {
      link.style.display = "none"; // Hide the link if no matching items
    }
  });
});

function openCity(evt, cityName) {
  evt.preventDefault();
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}


$(document).ready(function () {
  $(document).ready(function () {
    // Count the number of elements with class 'color-shade'
    var colorShadeCount = $(".color-shade").length;
    // alert(colorShadeCount)
    // Initialize Slick carousel if color-shade count is greater than 4
    if (colorShadeCount > 4) {
      $(".parent_shade").slick({
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        prevArrow: '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: '<button type="button" class="slick-next">Next</button>',
      });

      // Show/hide arrows based on the current slide index
      $(".parent_shade").on(
        "afterChange",
        function (event, slick, currentSlide) {
          if (currentSlide === 0) {
            $(".slick-prev").hide();
          } else {
            $(".slick-prev").show();
          }
          if (currentSlide >= slick.slideCount - slick.options.slidesToShow) {
            $(".slick-next").hide();
          } else {
            $(".slick-next").show();
          }
        }
      );

      // Initial check to display the correct arrows on load
      if ($(".parent_shade").slick("slickCurrentSlide") === 0) {
        $(".slick-prev").hide();
      } else {
        $(".slick-prev").show();
      }
    } else {
      // Hide arrows if color-shade count is 4 or less
      $(".slick-prev").hide();
      $(".slick-next").hide();
    }
    // Select all elements with the class "ColorSwatch"
    var HorizontalItems = document.querySelectorAll(".ColorSwatch");
    var MainProduct = document.querySelectorAll(".Product__SlideItem");
  

    HorizontalItems.forEach(function (item) {
      item.addEventListener("click", function () {
        var DataToolip = this.getAttribute("data-tooltip");

        // alert(DataToolip)
        // Your event handler code here
      });
    });
  });
});

$(document).ready(function () {
  $("body").on("click", ".delete_button", function () {
    $(this).parents(".Cart__ItemList").find(".popup_parent").css("display", "block");
  });
  $("body").on("click", ".close-svg-popup", function () {
    $(".popup_parent").css("display", "none");
  });
});

$("body").on("click", ".Edit", function (event) {
  var variantIdNew = $(this).attr("urlAttr");
  localStorage.setItem("variantCart", variantIdNew);
});

document.addEventListener("DOMContentLoaded", function () {
  var shareTitle = document.getElementById("share-title");
  var shareList = document.getElementById("share-list");
  var closeBtn = document.querySelector(".product_svg_close");
  $(shareTitle).click(function () {
    $(this).hide();
    $(shareList).css("display", "block");
    $(closeBtn).css("display", "block");
    $(".parent_icon_new").css("top", "-54%");
  });
  $(closeBtn).click(function () {
    $(shareList).css("display", "none");
    $(this).hide();
    $(shareTitle).css("display", "block");
    $(".parent_icon_new").css("top", "-1%");
  });
  $(".ProductMeta__ShareTitle").click(function () {
    $(this).hide();
    $(".ProductMeta__ShareItem_mobile").removeClass("hidden");
    $(".product_svg_close").removeClass("hidden");
    $(".custom_class").css("right","2%");
  });
  $(".product_svg_close").click(function () {
    $(this).addClass("hidden");
    $(".ProductMeta__ShareItem_mobile").addClass("hidden");
    $(".ProductMeta__ShareTitle").show();
  });
});


$(document).ready(function () {
  $(".bundleInner .bundle_swatch").click(function () {
    $(".bundle_swatch").removeClass("selectedOption");
    this.classList.add("selectedOption");
    var arr = [];
    var productSelectElements = document.querySelectorAll(".Product_select");
    productSelectElements.forEach(function (element) {
      var prodSelect = element.getAttribute("attrbundle");
      arr.push(prodSelect);
    });
    var swatchMain = this.parentElement.parentElement.getAttribute("attrId");
    if (arr.includes(swatchMain)) {
      var vBid = $(this).attr("data-variant-id");
      var bundleSelect = document.querySelectorAll(
        `#product-select-${swatchMain} option`
      );
      bundleSelect.forEach(function (element) {
        var proValue = element.getAttribute("value");
        if (vBid == proValue) {
          element.selected = true;
          var inputField = document.querySelector(
            `#product-select-${swatchMain}`
          );
          inputField.value = proValue;
          $(".addtocart_button .atc-text").text("Add to bag");
          const atc_elements = document.querySelectorAll(
            ".ProductForm__AddToCart"
          );
          atc_elements.forEach((element) => {
            var spanText = $(element).find(".atc-text").text();
            if (spanText == "Add to bag") {
              element.removeAttribute("disabled");
            }
          });
        }
      });
    }
  });

  $("body").on("click", ".HorizontalList__Item", function () {
    var VariantTitle = $(this).attr("variant_title");
    var imgSrc = $(this).attr("data-img-src");
    $(this)
      .closest(".ProductItem")
      .find(".ProductItem__Image")
      .attr("src", imgSrc);
    $(this)
      .parent(".collection_variant")
      .siblings(".selected_variant")
      .removeClass("hidden");
    $(this)
      .parent(".collection_variant")
      .siblings(".selected_variant")
      .text(VariantTitle);
  });
  $("body").on("click", ".ColorSwatch--large", function () {
    $(".ColorSwatch--large").removeClass("colorSwatch--active");
    $(this).addClass("colorSwatch--active");
  });

  $(".color-shade").click(function () {
    $(".HorizontalList__Item");
  });
  
$(".Popover__Value").click(function() {
    // Get the color code from the clicked element
    var ColorCode = $(this).attr("colocode");
    var parts = ColorCode.split(',');
    var hexColor = parts[0];
   
    $(".new_variant_dropdown").css("background-color", hexColor);
});
  $(".ColorSwatch ").click(function() {
    // Get the background-color of the .ColorSwatch element
    var bgColor = $(this).css("background-color");
    $(".new_variant_dropdown").css("background-color", bgColor);
});

  $(".color-shade").click(function () {
    $(".remaining_variant").hide();
    $(".down_arrow").hide();
  });
 $(".all-shade").click(function () {
    $(".ColorSwatchList").css("max-height", "auto");
   $(".ColorSwatchList").css("width", "456px");
    $(".remaining_variant").show();
    $(".down_arrow").hide();
  });
 $(".remaining_variant").click(function(){
      $(this).hide();
      $(".ColorSwatchList").css("max-height","max-content");
       // $(".ColorSwatchList").css("width","auto");
       $(".down_arrow").css("display", "block");
    // $(".custom-width").css("width","353px !important")
    $(".ColorSwatchList").css("margin-top","9px");

    });
  $(".down_arrow").click(function () {
    $(".ColorSwatchList").css("max-height", "103px");
    $(".ColorSwatchList").css("width", "456px");
    $(".remaining_variant").show();
    $(this).hide();
     // $(".custom-width").css("width","319x")
    $(".ColorSwatchList").css("margin-top","19px");
     
  });
  if (window.innerWidth <= 640) {
    $(".down_arrow").click(function () {
    $(".ColorSwatchList").css("max-height", "auto");
    $(".ColorSwatchList").css("width", "325px");
  });
    $(".all-shade").click(function () {
    $(".ColorSwatchList").css("max-height", "auto");
   $(".ColorSwatchList").css("width", "325px");
  });
     $("body").on("click", ".color-shade", function () {
    var $this = $(this);

    // Remove background color from all color-shades
    $(".color-shade").removeClass("active-shade").css("background-color", "");
$(".color-shade").removeClass("active-shade").css("color", "#000");
    // Add active-shade class to the clicked element
    $this.addClass("active-shade");

    // Apply background color to the clicked element if it has the active class
    var colorName = $this.attr("background-color");
    if (colorName) {
        $this.css("background-color", colorName);
        $this.css("color","#fff"); 
    }
});
  }
});

$(document).ready(function(){
  $('.variant_popproduct').slick({
  arrows: true,
  slidesToShow: 8,
  slidesToScroll: 4,
  infinite: false,
  prevArrow: $('.SlideshowNav--previous'),
  nextArrow: $('.SlideshowNav--next'),
  vertical: true,
  verticalSwiping: true,
  responsive: [
    {
      breakpoint: 768, // screens 768px and below
      settings: {
        slidesToShow: 6,  // Show 4 slides
        slidesToScroll: 2, // Scroll 2 slides at a time
        vertical: false,   // Switch to horizontal on mobile
        verticalSwiping: false
      }
    }
  ]
});

  $('.cell svg').click(function(){
    $(this).parent().trigger('click');
  });

var bloom = [];
bloom.push({
  id: 41918029037703,
  quantity: 1,
});
bloom.push({
  id: 41917818044551,
  quantity: 1,
});
bloom.push({
  id: 41963534221447,
  quantity: 1,
});
function add_bloom_fnc() {
  var add_bloom = {
    items: bloom,
  };
  $.ajax({
    url: "/cart/add.js",
    dataType: "json",
    cache: false,
    type: "post",
    data: add_bloom,
    success: function (data) { 
    },
  });
}
$('.add_card_btn').click(function(){
   window.location.href= 'https://www.lakmeindia.com/products/red-carpet-glam-look';
  }); 
}); 

document.addEventListener('DOMContentLoaded', function() {
  // Check if .variant-primary exists and add the event listener
  const primaryButton = document.querySelector('.variant-primary');
  if (primaryButton) {
    primaryButton.addEventListener('click', function() {
      alert('One');
      document.querySelector('.PageContent--narrow')?.classList.add('bottomProperty');
    });
  }

  // Check if .show-element .hydrated button exists and add the event listener
  const secondaryButton = document.querySelector('.show-element .hydrated button');
  if (secondaryButton) {
    secondaryButton.addEventListener('click', function() {
      alert('Two');
      document.querySelector('.PageContent--narrow')?.classList.remove('bottomProperty');
    });
  } 
});

function setCookies(cnames, cvalue, exdays) {
  const ds = new Date();
  ds.setTime(ds.getTime() + (exdays*24*60*60*1000));
  let expiress = "expiress="+ ds.toUTCString();
  document.cookie = cnames + "=" + cvalue + ";" + expiress + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

 $(".HorizontalList__Item.Help").hover(function () {
    $(this).trigger("click");
  });

  $(".HorizontalList__Item.Categories, .HorizontalList__Item.Orders").hover(function () {
    $(this).trigger("click");
  });

$(".scroll-link").on("click", function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
 var headerHeight = $(".Header__Wrapper").outerHeight();
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top- (headerHeight + 20),
      },
      800 
    );
  });
$(window).on("load", function () {
  $('a[href^="#"]').on("click", function (e) {
    // sirf desktop (>=768px) pe custom scroll chalao, mobile pe default rehne do
    if ($(window).width() < 768) return;

    var hash = $(this).attr("href");
    var target = $(hash);

    if (!target.length) return;

    e.preventDefault();

    var headerHeight = $(".Header__Wrapper").outerHeight() || 0;

    $("html, body").animate(
      {
        scrollTop: target.offset().top - (headerHeight + 60),
      },
      800
    );
  });
});
document.querySelectorAll('.view-product-btn a').forEach(function(link) {
  link.addEventListener('click', function(e) {
    e.stopPropagation(); 
    e.preventDefault();  
    window.open(this.href, '_blank');
  });
});
$("body").on("click", ".CartItem__Remove", function () {
  //checkFreeProduct();
});

function checkFreeProduct(cart) {
  console.log("click---", cart.items.length);
  console.log("Total---", cart.total_price);
  console.log(cart);

  var totalPrice = cart.total_price;
  console.log(typeof totalPrice);
  let product_var = [];
  for (var i = 0; i < cart.items.length; i++) {
    product_var.push(cart.items[i].product_id);
  }

  if (parseInt(totalPrice ) > 84900 ) {
    // Call addee() function
    if (product_var.includes(7480860967047) ||
    product_var.includes(7518021845127) ||
    product_var.includes(7537635295367) ||
    product_var.includes(7537629986951) ||
    product_var.includes(7537624580231) ||
    product_var.includes(7537600364679) ||
    product_var.includes(7422476157063)
  ) {
    console.warn("Add free product!! nnnn");
    setTimeout(function () {
      if(product_var.includes(6621872128135)){
        
      } else{
        addee();
      }
      
      console.log(cart);
    }, 600);
    }
  } else if (
    parseInt(totalPrice) <= 84900 && product_var.includes(7480860967047) ||
      product_var.includes(7518021845127) ||
      product_var.includes(7537635295367) ||
      product_var.includes(7537629986951) ||
      product_var.includes(7537624580231) ||
      product_var.includes(7537600364679) ||
      product_var.includes(7422476157063)
  ) {
    // Call removeItem() function
    console.warn("Remove product!!");
    removeItem();
    console.log(cart);
  } else {
    // Call removeItem() function for any other case in else block
    console.warn("No action required!!");
    removeItem();
    console.log(cart);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const targetAttr = "42933460402311:7ffc956fe7892854f160afec6d80ed97";
  
  // Find the target product
  const targetElement = document.querySelector(`[data-line-id="${targetAttr}"]`);
  
  if (targetElement) {
    const cartItem = targetElement.closest('.CartItemWrapper');
    const parent = cartItem.parentNode;

    // Move it to the end of the parent container
    parent.appendChild(cartItem);
  }
});





window.addProductOnPrice = function () {
  const GIFT2_VARIANT_ID = 43036377776263; 
  const GIFT3_VARIANT_ID = 43412310065287; 
  const GIFT4_VARIANT_ID = 43036378628231; 

  const PRICE_THRESHOLD_600 = 60000;   
  const PRICE_THRESHOLD_800 = 80000;   
  const PRICE_THRESHOLD_1000 = 100000; 

  fetch('/cart.js')
    .then(res => res.json())
    .then(cartData => {
      const cartTotal = cartData.total_price;
      const itemsToAdd = [];
      const itemsToRemove = [];
      // debugger;
      
      const isAutoGift = (item, variantId) =>
        item.id === variantId && item.properties && item.properties.autoGift === "true";

      
      const gift2Item = cartData.items.find(item => item.id === GIFT2_VARIANT_ID);
      if (cartTotal >= PRICE_THRESHOLD_600) {
        if (!gift2Item) {
          itemsToAdd.push({
            id: GIFT2_VARIANT_ID,
            quantity: 1,
            properties: { autoGift: "true" }
          });
        }
      } else if (gift2Item && isAutoGift(gift2Item, GIFT2_VARIANT_ID)) {
        itemsToRemove.push(gift2Item.key);
      }

      
      const gift3Item = cartData.items.find(item => item.id === GIFT3_VARIANT_ID);
      if (cartTotal >= PRICE_THRESHOLD_800) {
        if (!gift3Item) {
          itemsToAdd.push({
            id: GIFT3_VARIANT_ID,
            quantity: 1,
            properties: { autoGift: "true" }
          });
        }
      } else if (gift3Item && isAutoGift(gift3Item, GIFT3_VARIANT_ID)) {
        itemsToRemove.push(gift3Item.key);
      }

      
      const gift4Item = cartData.items.find(item => item.id === GIFT4_VARIANT_ID);
      if (cartTotal >= PRICE_THRESHOLD_1000) {
        if (!gift4Item) {
          itemsToAdd.push({
            id: GIFT4_VARIANT_ID,
            quantity: 1,
            properties: { autoGift: "true" }
          });
        }
      } else if (gift4Item && isAutoGift(gift4Item, GIFT4_VARIANT_ID)) {
        itemsToRemove.push(gift4Item.key);
      }

      
      if (itemsToAdd.length) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({ items: itemsToAdd })
        }).then(() => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }))
        });
      }

      
      if (itemsToRemove.length) {
        const updates = {};
        itemsToRemove.forEach(key => {
          updates[key] = 0;
        });

        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({ updates })
        }).then(() => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }))
        });
      }
    })
    .catch(err => console.error("Error in addProductOnPrice:", err));
};

// disable checkout button

document.addEventListener("DOMContentLoaded", function () {
  function checkFreeGiftOnly() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const freeGiftIds = [
          42933460402311,
          43036378628231,
          43036377776263,
          43412310065287
        ];

        const onlyFreeGifts = cart.items.length > 0 &&
          cart.items.every(item => freeGiftIds.includes(item.variant_id));

        if (onlyFreeGifts) {
          document.querySelectorAll('button[name="checkout"], .Cart__Checkout').forEach(btn => {
            btn.style.pointerEvents = "none";
            btn.style.opacity = "0.5";
            btn.setAttribute("disabled", "true");
          });
        } else {
          document.querySelectorAll('button[name="checkout"], .Cart__Checkout').forEach(btn => {
            btn.style.pointerEvents = "auto";
            btn.style.opacity = "1";
            btn.removeAttribute("disabled");
          });
        }
      });
  }

  checkFreeGiftOnly();

  document.addEventListener("cart:updated", checkFreeGiftOnly);
});



// here i write a code for custom-search.js


  document.addEventListener('DOMContentLoaded', function () {
    const cstminputvalue = document.querySelector('.search-input');
    const cstmCollectionValue = document.querySelectorAll('.collection-item');
    const cstmProductvalue = document.querySelectorAll('.cstm-product-item');
    const productHeading = document.querySelector('.cstm-search-product h4');
    const collectionHeading = document.querySelector('.somethingnew h4');
    const cstmsearchmaincontainer = document.querySelector('.cstm-search-product-collection');
    const viewMoreBtn = document.querySelector('.view-more-btn');
    const defaultTrendingSearch = document.querySelector('.forDefaultSearch');
    const searchsvg = document.querySelector('.open_main_cust_search_bar');

    cstmsearchmaincontainer.style.display = 'none';
    viewMoreBtn.style.display = 'none';
    

    searchsvg.addEventListener('click',function(){
    if(cstminputvalue.value == '') {
      defaultTrendingSearch.style.display="block"
    }
    else{
   defaultTrendingSearch.style.display="none"

    }
    })

    cstminputvalue.addEventListener('focus', function () {
  if (cstminputvalue.value.trim() === '') {
    defaultTrendingSearch.style.display = "block";
    cstmsearchmaincontainer.style.display = "none";
  } else {
    defaultTrendingSearch.style.display = "none";
  }
});

    cstminputvalue.addEventListener('keyup', function () {
      const value = this.value.toLowerCase().trim();

      if (value.length >= 1) {
        cstmsearchmaincontainer.style.display = 'block';
        defaultTrendingSearch.style.display="none"
      } else {
        cstmsearchmaincontainer.style.display = 'none'; 
      }

      let matchedProducts = [];

      cstmProductvalue.forEach((proitem) => {
        const prodcuttitle = proitem.dataset.product;

        if (value.length < 3) {
          proitem.style.display = 'none';
        } else if (prodcuttitle.includes(value)) {
          matchedProducts.push(proitem);
        } else {
          proitem.style.display = 'none';
        }
      });

      matchedProducts.forEach((item, index) => {
        if (index < 6) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });

      if (matchedProducts.length > 6) {
        viewMoreBtn.style.display = 'block';
      } else {
        viewMoreBtn.style.display = 'none';
      }

      // Count for headings
      const productCount = matchedProducts.length;

      // 🔍 Collections filtering
      let collectionCount = 0;

      cstmCollectionValue.forEach((item) => {
        const title = item.dataset.item;

        if (value === '') {
          item.style.display = 'none';
        } else if (title.startsWith(value)) {
          item.style.display = 'block';
          collectionCount++;
        } else {
          item.style.display = 'none';
        }
      });

      productHeading.style.display = productCount > 0 ? 'block' : 'none';
      collectionHeading.style.display = collectionCount > 0 ? 'block' : 'none';
    });
  });

  
const searchPhrases = [
  "Eye Liner",
  "foundation",
  "Lipstick"
];

let index = 0;
let charindex = 0;
let isDeleting = false;

function updateTyping() {
  const searchinput = document.querySelector('.cstm_search_input_placeholder');
  if (!searchinput) return;

  const phrase = searchPhrases[index];

  const currentText = isDeleting
    ? phrase.substring(0, --charindex)
    : phrase.substring(0, ++charindex);

  searchinput.placeholder = "search for " + currentText;

  if (!isDeleting && charindex === phrase.length) {
    isDeleting = true;
    setTimeout(updateTyping, 1200);

  } else if (isDeleting && charindex === 0) {
    isDeleting = false;
    index = (index + 1) % searchPhrases.length;
    setTimeout(updateTyping, 400);

  } else {
    setTimeout(updateTyping, isDeleting ? 60 : 100);
  }
}

updateTyping();


// here i end a code for custom-search.js 
// cstm add to cart

// function updateATCByVariant(swatch) {
//   if (!swatch) return;

//   const variantId = swatch.dataset.variantId;
//   const available = swatch.dataset.available === "true";
//   const productCard = swatch.closest(".ProductItem, .product-card, .collection_atc");
//   if (!productCard) return;

//   const atcButton = productCard.querySelector(".addtocart_button");
//   const viewProductBtn = productCard.querySelector(".view-product-btn");
//   const variantInput = productCard.querySelector(".selected-variant-id");
//   if (variantInput) variantInput.value = variantId;

//   if (atcButton) {
//     atcButton.setAttribute("data-variant-id", variantId);
//     atcButton.setAttribute("variant_id", variantId);
//   }
//   if (atcButton) {
//     atcButton.style.display = "none";
//     atcButton.disabled = false;
//   }
//   if (viewProductBtn) {
//     viewProductBtn.style.display = "none";
//   }
//   if (available) {
//     if (atcButton) {
//       atcButton.style.display = "flex";
//     }
//   } else {
//     if (viewProductBtn) {
//       viewProductBtn.style.display = "block";
//     }
//   }
//   productCard.querySelectorAll(".color-swatch").forEach(s =>
//     s.classList.remove("active")
//   );
//   swatch.classList.add("active");
// }

// document.addEventListener("click", function (e) {
//   const swatch = e.target.closest(".color-swatch");
//   if (!swatch) return;
//   updateATCByVariant(swatch);
// });
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".ProductItem, .product-card, .collection_atc").forEach(card => {
//     const activeSwatch =
//       card.querySelector(".color-swatch.active") ||
//       card.querySelector(".color-swatch");

//     if (activeSwatch) {
//       updateATCByVariant(activeSwatch);
//     }
//   });
// });

function updateATCByVariant(swatch) {
  if (!swatch) return;

  const variantId = swatch.dataset.variantId;
  const available = swatch.dataset.available === "true";
  const productCard = swatch.closest(".ProductItem, .product-card, .collection_atc");
  if (!productCard) return;

  const atcButton = productCard.querySelector(".addtocart_button");
  const viewProductBtn = productCard.querySelector(".view-product-btn");

  const variantInput =
    productCard.querySelector('input[name="id"]') ||
    productCard.querySelector(".selected-variant-id");
  if (variantInput) variantInput.value = variantId;
  if (atcButton) {
    atcButton.disabled = false;
    atcButton.removeAttribute("disabled");
    atcButton.classList.remove("is-loading", "disabled", "loading");
    atcButton.style.pointerEvents = "auto";
    atcButton.style.opacity = "1";
  }
  if (atcButton) atcButton.style.display = "none";
  if (viewProductBtn) viewProductBtn.style.display = "none";
  if (available) {
    if (atcButton) atcButton.style.display = "flex";
  } else {
    if (viewProductBtn) viewProductBtn.style.display = "block";
  }
  productCard.querySelectorAll(".color-swatch").forEach(s =>
    s.classList.remove("active")
  );
  swatch.classList.add("active");
}
document.addEventListener("click", function (e) {
  const swatch = e.target.closest(".color-swatch");
  if (!swatch) return;
  updateATCByVariant(swatch);
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ProductItem, .product-card, .collection_atc").forEach(card => {

    // Pehle active aur available swatch dhoondo
    let defaultSwatch = card.querySelector('.color-swatch.active[data-available="true"]');

    // Agar nahi mila to first available swatch
    if (!defaultSwatch) {
      defaultSwatch = card.querySelector('.color-swatch[data-available="true"]');
    }

    // Agar koi available hi nahi hai to active ya first swatch
    if (!defaultSwatch) {
      defaultSwatch =
        card.querySelector(".color-swatch.active") ||
        card.querySelector(".color-swatch");
    }

    if (defaultSwatch) {
      updateATCByVariant(defaultSwatch);
    }
  });
});

document.addEventListener("submit", function (e) {
  const form = e.target;
  const button = form.querySelector(".addtocart_button");
  if (!button) return;
  setTimeout(() => {
    button.disabled = false;
    button.removeAttribute("disabled");
    button.classList.remove("is-loading", "disabled", "loading");
    button.style.pointerEvents = "auto";
    button.style.opacity = "1";
  }, 800);
});

